import { render, staticRenderFns } from "./orderbook.vue?vue&type=template&id=9f0af91a"
import script from "./orderbook.vue?vue&type=script&lang=js"
export * from "./orderbook.vue?vue&type=script&lang=js"
import style0 from "./orderbook.vue?vue&type=style&index=0&id=9f0af91a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports